module.exports = __webpack_public_path__ + "f7bc096d0bef0d429602ac91953feb98.pdf";